/*
 * =============================================================================
 * Project: boilerplate
 * Created Date: 2018-03-12, 08:59:54
 * Author: Przemysław Drzewicki <przemyslaw.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-04-10, 14:38:39
 * Modified By: Przemysław Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada S.A
 * =============================================================================
 */
import ENUM from "es6-enum";
import { createAction } from "helpers/utils";

const LOGIN = ENUM('STATIC', 'SUCCESS', 'FAIL');
const LOGOUT = ENUM('STATIC', 'SUCCESS', 'FAIL');
const CHECK_IS_USER_LOGIN = ENUM('STATIC', 'SUCCESS', 'FAIL');

const initialState = {
  user: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOGIN.STATIC:
    case LOGOUT.STATIC:
    case CHECK_IS_USER_LOGIN.STATIC:
      return {
        ...state
      };
    case LOGIN.SUCCESS:
      return {
        ...state,
        user: action.result
      };
    case LOGOUT.SUCCESS:
      return {
        ...state,
        user: null
      };
    case CHECK_IS_USER_LOGIN.SUCCESS:
      return {
        ...state,
        user: action.result
      };
    case LOGIN.FAIL:
    case LOGOUT.FAIL:
    case CHECK_IS_USER_LOGIN.FAIL:
      return {
        ...state,
        user: null,
        error: action.error
      };
    default:
      return state;
  }
}

/**
 * Login user.
 * 
 * @export
 * @param {any} [data={}] 
 * @returns 
 */
export function loginUser(data = {}) {
  return createAction(LOGIN, '/authorization', 'post', data);
}

/**
 * Logout user.
 * 
 * @export
 */
export function logoutUser() {
  return createAction(LOGOUT, '/authorization', 'delete');
}

/**
 * Check is user session exist.
 * 
 * @export
 */
export function checkIsUserSessionExist() {
  return createAction(CHECK_IS_USER_LOGIN, '/authorization', 'get');
}


// WEBPACK FOOTER //
// ./src/rcapp/redux/actions/authorization.js